import React, { ReactNode } from 'react'
import { notYetImplementedWithError } from '../../../utils'
import { IWizardStepContext, StepName } from '../types'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface PaymentStepFormData {}

const PaymentStepContext = React.createContext<IWizardStepContext<PaymentStepFormData>>({
  name: StepName.Payment,
  data: {},
  setStepData: notYetImplementedWithError,
  validateStepData: notYetImplementedWithError
})

export const PaymentStepProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [data, setStepData] = React.useState({})

  const value = React.useMemo<IWizardStepContext<PaymentStepFormData>>(() => {
    const validateStepData = (): void => {}

    return {
      name: StepName.Payment,
      data,
      setStepData,
      validateStepData
    }
  }, [data])

  return (
    <PaymentStepContext.Provider value={value}>
      {children}
    </PaymentStepContext.Provider>
  )
}

export default PaymentStepContext
